import { render, staticRenderFns } from "./MatchesGrouping.vue?vue&type=template&id=27b555f1&"
import script from "./MatchesGrouping.vue?vue&type=script&lang=js&"
export * from "./MatchesGrouping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports